import { useFormsListStore } from "@/serviforms/forms/store";
import $t from "@/i18n/";
export default [
  {
    path: "/dashboard/companies",
    name: "Companies",
    component: () => import(/* webpackChunkName: "Companies" */ "@/serviforms/Companies/Main.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/access/tokens",
    name: "Datasource",
    component: () => import(/* webpackChunkName: "Datasource" */ "@/serviforms/accessTokens/Main.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/datasource",
    name: "Datasource",
    component: () => import(/* webpackChunkName: "Datasource" */ "@/serviforms/Datasource/Main.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/migrate",
    name: "Migrate",
    component: () => import(/* webpackChunkName: "NewForm" */ "@/serviforms/Migrate-json/migrate.vue"),
    meta: {
      rule: "gotu",
      autentication: true
    }
  },
  {
    path: "/dashboard/keychains",
    name: "Keychains",
    component: () => import(/* webpackChunkName: "Keychains" */ "@/serviforms/Keychains/Main.vue"),
    meta: {
      //pageTitle: 'Keychains',
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/transfer/forms",
    name: "TransferForms",
    component: () => import(/* webpackChunkName: "Keychains" */ "@/serviforms/TransferForms/Main.vue"),
    meta: {
      //pageTitle: 'Keychains',
      rule: "gotu",
      autentication: true
    }
  },
  {
    path: "/dashboard/clients",
    name: "clientesvisit",
    component: () => import(/* webpackChunkName: "UsersList" */ "@/serviforms/visits/clients/clients.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/visits",
    name: "moduleVisits",
    component: () => import(/* webpackChunkName: "UsersList" */ "@/serviforms/visits/visits/visit.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/users",
    name: "eusers",
    component: () => import(/* webpackChunkName: "UsersList" */ "@/serviforms/users/Main.vue"),
    meta: {
      // breadcrumb: [{ title: "Home", url: "/" }, { title: "Dashboard" }, { title: "Users", active: true }],
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/users/assigned/bot",
    name: "botUser",
    component: () => import(/* webpackChunkName: "UsersList" */ "@/serviforms/users/assignedBot/index.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/groups",
    name: "Groups",
    component: () => import(/* webpackChunkName: "Groups" */ "@/serviforms/Groups/Main.vue"),
    meta: {
      rule: "express",
      autentication: true
    }
  },
  {
    path: "/dashboard/forms",
    name: "eforms",
    component: () => import(/* webpackChunkName: "FormList" */ "@/serviforms/forms/FormList.vue"),
    meta: {
      breadcrumb: [{ title: "Home", url: "/" }, { title: "Dashboard" }, { title: "Form", active: true }],
      dropdownMenu: {
        icon: "icon-settings",
        menu: [
          {
            tittle: `FORMSVIEW.dropdownMenu.update`,
            icon: 'RefreshCwIcon',
            handler: () => useFormsListStore().getAllForms()
          },
          {
            tittle: `FORMSVIEW.dropdownMenu.all`,
            icon: 'CheckSquareIcon',
            handler: () => useFormsListStore().State(null)
          },          
          {
            tittle: `FORMSVIEW.dropdownMenu.actives`,
            icon: 'CheckCircleIcon',
            handler: () => useFormsListStore().State(1)
          },
          {
            tittle: `FORMSVIEW.dropdownMenu.deletes`,
            icon: 'MinusCircleIcon',
            handler: () => useFormsListStore().State(2)
          }
        ]
      },
      rule: "all",
      autentication: true
    }
  },
  {
    path: "/dashboard/multiforms",
    name: "Multiforms",
    component: () => import(/* webpackChunkName: "Multiforms" */ "@/serviforms/MultiForms/Main.vue"),
    meta: {
      rule: "express",
      autentication: true
    }
  },
  {
    path: "/dashboard/new/formularios/:id?/:last?",
    name: "newForm",
    component: () => import(/* webpackChunkName: "NewForm" */ "@/serviforms/designer/Main.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/new/form/:id?/:last?",
    name: "newForm",
    component: () => import(/* webpackChunkName: "NewForm" */ "@/serviforms/designer/Main.vue"),
    meta: {
      rule: "admin",
      autentication: true
    }
  },
  {
    path: "/dashboard/profile/user",
    name: "ProfileUser",
    component: () => import(/* webpackChunkName: "Keychains" */ "@/serviforms/profile/Profile.vue"),
    meta: {
      rule: "express",
      autentication: true
    }
  },
  {
    path: "/dashboard/connections",
    name: "Connections",
    component: () => import(/* webpackChunkName: "Keychains" */ "@/serviforms/connections/Main.vue"),
    meta: {
      //pageTitle: 'Keychains',
      rule: "gotu",
      autentication: true
    }
  },
  {
    path: "/dashboard/statistics",
    name: "dashboard-statistics",
    component: () => import(/* webpackChunkName: "Keychains" */ "@/serviforms/analitics/Main.vue"),
    meta: {
      //pageTitle: 'Keychains',
      rule: "gotu",
      autentication: true
    }
  }
];
